import Tool from "./Tool";
import Vector2 from "./Vector2";
import Rect from "./Rect";
import MouseEventArgs, { MouseButton } from "./MouseEventArgs";
import Editor from "../editor/Editor";

export default class MoveTool extends Tool {
  private _dragging = false;
  private _startMousePos: Vector2 = null;
  private _startRect: Rect = null;

  public constructor(editor: Editor) {
    super(editor, "move");
  }

  public handleMouseDown(arg: MouseEventArgs): boolean {
    if (arg.button != MouseButton.Left) {
      return false;
    }

    var pos = arg.worldPosition;

    var selectedLayer = this.editor.rootLayerGroup.checkPointIntersection(pos);

    if (selectedLayer != null) {
      this.editor.setSelectedLayer(selectedLayer);
      this.editor.rootLayerGroup.bringToFront(selectedLayer);

      this._dragging = true;
      this._startMousePos = pos;
      this._startRect = selectedLayer.boundingRect;

      return true;
    } else {
      this.editor.setSelectedLayer(null);
    }

    return false;
  }

  public handleMouseMove(arg: MouseEventArgs): boolean {
    if (this._dragging == false) {
      return false;
    }
    var offset = arg.worldPosition.sub(this._startMousePos);

    var selectedLayer = this.editor.selectedLayer;

    var newRect = this._startRect.add(offset);

    selectedLayer.setBoundingRect(newRect);

    return true;
  }

  public handleMouseUp(arg: MouseEventArgs): boolean {
    if (this._dragging == false) {
      return false;
    }

    this._dragging = false;
    this._startMousePos = null;
    this._startRect = null;
    return true;
  }
}
